import styled from 'styled-components';
import { Container, Content } from '../../shared.styled';

export const ContainerWithRelative = styled(Container)`
  position: relative;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  background: rgba(255, 255, 255, 0.7);
`;

export const LoadingOverlayContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 24px 32px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

export const ContentWithOpacity = styled(Content)`
  opacity: ${(props) => (props.$isLoading ? 0.5 : 1)};
  transition: opacity 0.2s ease-in-out;
`;

/** Single-line truncation for chat starter text (CT-2387). */
export const StarterQuestionText = styled.span`
  display: block;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* Typography from @ann/web-components renders a child; ellipsis must apply there too */
  & > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    display: block;
  }
`;
